export const TOGGLE_POPUP = 'TOGGLE_POPUP';
export const TOGGLE_HOME_POSTER = 'TOGGLE_HOME_POSTER';
export const TOGGLE_GAME_POSTER = 'TOGGLE_GAME_POSTER';

// action.js
export const togglePopup = () => ({
  type: TOGGLE_POPUP,
});

export const toggleHomePoster = () => ({
  type: TOGGLE_HOME_POSTER,
});

export const toggleGamePoster = () => ({
  type: TOGGLE_GAME_POSTER,
});

